<template>

  <div class="section section-white">
    <el-card>
      <el-alert
              title="活动价格"
              type="info"
              description=""
              show-icon>
      </el-alert>
    </el-card>
    <el-form v-model="form" label-width="160px">

      <el-form-item label="活动名称">
        <el-input v-model="form.title"  placeholder="请输入活动名称"></el-input>
      </el-form-item>

      <el-form-item label="活动开始时间">
        
        <el-col :span="6">
              <el-date-picker type="date" placeholder="选择开始时间"
                              value-format="yyyy-MM-dd "
                              v-model="form.start_time"  style="width: 100%;"></el-date-picker>
            </el-col>
      </el-form-item>
      <el-form-item label="活动结束时间">
        
        <el-col :span="6">
              <el-date-picker type="date" placeholder="选择结束时间"
                              value-format="yyyy-MM-dd "
                              v-model="form.end_time"  style="width: 100%;"></el-date-picker>
            </el-col>
      </el-form-item>
      

      <el-form-item label="活动描述">
        <el-input v-model="form.msg"  placeholder="活动时间"></el-input>
      </el-form-item>
      
    </el-form>
    <div slot="footer" class="dialog-footer content-center">

      <el-button type="primary" @click="handleSave" > 确定 </el-button>
    </div>
  </div>

</template>
<script>
    import { mapGetters } from 'vuex'
    import {saverReviewPriceTitle} from '@/api/goods'

    import richTextEditor from '@/components/function/richTextEditor'
    import imgPicker from '@/components/imageselect'
    export default {
        components: {
            imgPicker,
            richTextEditor,
        },
        data () {
            return {
                pickerImgType: "",
                pickerImgType_index:"",
                copy_flag:false,
                clickable:false,
                dialog: false,
                distributor_dialog:false,
                relDistributors:[],
                DistributorVisible: false,
                DistributorStatus: false,
                isValid: true,
                activeName: 'admin',
                list: [],
                total_count: 0,
                loading: false,
                DistributorName:'',
                form: {
                    title:'',
                    start_time:'',
                    end_time:'',
                    msg:'',
                },
                active_time_f : '',
                deadline_time : '',
                date_time : '',
                mode: 'richText',
                thumbDialog:false,
                picsDialog: false,
                imgDialog: false,
                isGetImage: false,
                isGetThumb: false,
                imgIndex: 0,
                submitLoading:false,
            }
        },
        computed: {
            ...mapGetters([
                'wheight'
            ])
        },
        methods: {
            
            

            handleCurrentChange (val) {
                this.currentPage = val
                this.loading = false
            },
            
            
            closeThumbDialog: function () {
                this.thumbDialog = false
                this.isGetThumb = false
            },
            
            // 保存
            handleSave(){

                const that = this
                console.log(this.form)
                saverReviewPriceTitle(this.form).then(res => {
                    this.$message({
                        message: '添加成功',
                        type: 'success',
                        duration: 2 * 1000,
                        onClose () {
                            that.$router.go(-1)
                        }
                    })
                }).catch( error  => {
                    this.$message.error('添加失败!')
                    this.submitLoading = false
                })
            },
            
            closeImgDialog () {
                this.imgDialog = false
                this.isGetImage = false
            },
            
            
        },
        mounted () {
           
        }

    }
</script>

<style scoped lang="scss">
  .upload-preview {
    text-align: center;
    max-width: 200px;
    border: 1px solid #ddd;
    padding: 10px;
    position: relative;
    img {
      max-width: 200px;
      margin: 0 auto;
    }
  }
  .text-ellipsis {
    display: inline-block;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .vue-html5-editor {
    vertical-align: top;
    display: inline-block;
  }
  .vue-html5-editor {
    width: 80%;
  }
</style>



// WEBPACK FOOTER //
// priceviewtitle.vue?57bdcc8c